// src/pages/ViewApplications.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { applicationApi, requirementApi } from '../../feddback-services/api';
import './ViewApplications.css';

import TrainingPaymentPopup from '../paymentpopup/TrainingPaymentPopup';
import JoinedFormView from '../JoinedFormView/JoinedFormView';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import {
  faEye, faFilePdf, faList,
  faGraduationCap, faMoneyBillWave,
  faUserCheck
} from '@fortawesome/free-solid-svg-icons';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://api.jmkinfosoft.com';

const NOTICE_PERIOD_OPTIONS = [
  { value: '', label: 'Any' },
  { value: '0', label: 'Immediate' },
  { value: '7', label: 'Within 7 Days' },
  { value: '15', label: 'Within 15 Days' },
  { value: '30', label: 'Within 30 Days' },
  { value: '45', label: 'Within 45 Days' },
  { value: '60', label: 'Within 60 Days' },
  { value: '90', label: 'Within 90 Days' }
];

const DATE_FILTER_OPTIONS = [
  { value: '', label: 'All Time' },
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'last7', label: 'Last 7 Days' },
  { value: 'last15', label: 'Last 15 Days' },
  { value: 'last30', label: 'Last 30 Days' },
  { value: 'last60', label: 'Last 60 Days' },
  { value: 'last90', label: 'Last 90 Days' }
];

const ViewApplications = () => {
  const navigate = useNavigate();
  const [requirements, setRequirements] = useState([]);
  const [selectedRequirement, setSelectedRequirement] = useState(null);
  const [applications, setApplications] = useState([]);
  const [selectedApplication, setSelectedApplication] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [loadingApps, setLoadingApps] = useState(false);
  const [error, setError] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    education: '',
    preferred_location: '',
    notice_period: '',
    applied_date: ''
  });

  const [selectedCandidates, setSelectedCandidates] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [showBroadcastModal, setShowBroadcastModal] = useState(false);
  const [broadcastMessage, setBroadcastMessage] = useState('');
  const [sendingBroadcast, setSendingBroadcast] = useState(false);
  const [broadcastProgress, setBroadcastProgress] = useState({ current: 0, total: 0 });

  const [activeTab, setActiveTab] = useState('applications');

  const [trainingSearchTerm, setTrainingSearchTerm] = useState('');
  const [trainingFilters, setTrainingFilters] = useState({
    education: '',
    preferred_location: '',
    notice_period: '',
  });

  const [joinedSearchTerm, setJoinedSearchTerm] = useState('');
  const [joinedFilters, setJoinedFilters] = useState({
    education: '',
    preferred_location: '',
    notice_period: '',
  });

  const [showPaymentPopup, setShowPaymentPopup] = useState(false);
  const [selectedPaymentCandidate, setSelectedPaymentCandidate] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);

  const [showBulkPaymentPopup, setShowBulkPaymentPopup] = useState(false);
  const [bulkCandidates, setBulkCandidates] = useState([]);

  const [trainingDates, setTrainingDates] = useState({});
  const [updatingTrainingDates, setUpdatingTrainingDates] = useState({});

  const [selectedTrainingCandidates, setSelectedTrainingCandidates] = useState([]);
  const [selectAllTraining, setSelectAllTraining] = useState(false);

  const [selectedJoinedCandidates, setSelectedJoinedCandidates] = useState([]);
  const [selectAllJoined, setSelectAllJoined] = useState(false);

  const [showBulkTrainingModal, setShowBulkTrainingModal] = useState(false);
  const [showBulkJoinedModal, setShowBulkJoinedModal] = useState(false);
  const [sendingBulkTraining, setSendingBulkTraining] = useState(false);
  const [sendingBulkJoined, setSendingBulkJoined] = useState(false);
  const [bulkTrainingProgress, setBulkTrainingProgress] = useState({ current: 0, total: 0 });
  const [bulkJoinedProgress, setBulkJoinedProgress] = useState({ current: 0, total: 0 });

  const [updatingDocStatus, setUpdatingDocStatus] = useState(null);

  const [showFormViewModal, setShowFormViewModal] = useState(false);
  const [formViewData, setFormViewData] = useState(null);
  const [loadingFormView, setLoadingFormView] = useState(false);

  const [exportingData, setExportingData] = useState(false);

  const [searchDebounceTimer, setSearchDebounceTimer] = useState(null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const role = localStorage.getItem('userRole');

    if (!token) {
      navigate('/login');
      return;
    }

    if (!['admin', 'super_admin', 'external_admin'].includes(role)) {
      navigate('/user/view-requirement');
      return;
    }

    fetchRequirements();
  }, []);

  useEffect(() => {
    const savedPayments = localStorage.getItem('paymentHistory');
    if (savedPayments) {
      try {
        setPaymentHistory(JSON.parse(savedPayments));
      } catch (e) {
        console.error('Error loading payment history:', e);
      }
    }
  }, []);

  useEffect(() => {
    const savedDates = localStorage.getItem('trainingDates');
    if (savedDates) {
      try {
        setTrainingDates(JSON.parse(savedDates));
      } catch (e) {
        console.error('Error loading training dates:', e);
      }
    }
  }, []);

  useEffect(() => {
    if (applications.length > 0) {
      const savedDates = JSON.parse(localStorage.getItem('trainingDates') || '{}');
      let updated = false;

      applications.forEach(app => {
        if (app.status === 'training') {
          const appDates = savedDates[app.id] || {};
          if (app.training_join_date && !appDates.joining_date) {
            savedDates[app.id] = {
              ...appDates,
              joining_date: app.training_join_date
            };
            updated = true;
          }
          if (app.training_end_date && !appDates.ending_date) {
            savedDates[app.id] = {
              ...(savedDates[app.id] || {}),
              ending_date: app.training_end_date
            };
            updated = true;
          }
        }
      });

      if (updated) {
        localStorage.setItem('trainingDates', JSON.stringify(savedDates));
        setTrainingDates(savedDates);
      }
    }
  }, [applications]);

  useEffect(() => {
    if (selectedRequirement) {
      if (searchDebounceTimer) {
        clearTimeout(searchDebounceTimer);
      }

      const timer = setTimeout(() => {
        fetchApplicationsForRequirement(selectedRequirement.id);
      }, 500);

      setSearchDebounceTimer(timer);

      return () => {
        if (timer) {
          clearTimeout(timer);
        }
      };
    }
  }, [searchTerm, filterStatus, filters]);

  const getFilterOptions = (key) => {
    const options = new Set();
    applications.forEach(app => {
      const value = app.candidate_profile?.[key] || app[key];
      if (value) {
        if (Array.isArray(value)) {
          value.forEach(v => options.add(v));
        } else {
          options.add(value);
        }
      }
    });
    return Array.from(options).sort();
  };

  const fetchRequirements = async () => {
    setLoading(true);
    setError('');
    try {
      const response = await requirementApi.list({ page: 1, limit: 100 });
      const data = response.data.data || response.data;
      setRequirements(data.items || []);
    } catch (err) {
      console.error('Error fetching requirements:', err);
      setError('Failed to load requirements. Please try again.');
      if (err.response?.status === 401) {
        navigate('/login');
      }
    } finally {
      setLoading(false);
    }
  };

  const getFieldValue = (obj, possibleKeys, defaultValue = 'N/A') => {
    if (!obj || typeof obj !== 'object') return defaultValue;
    for (const key of possibleKeys) {
      if (obj[key] !== undefined && obj[key] !== null && obj[key] !== '') {
        return obj[key];
      }
    }
    return defaultValue;
  };

  const getSkillsArray = (obj, possibleKeys) => {
    if (!obj || typeof obj !== 'object') return [];
    for (const key of possibleKeys) {
      if (obj[key] !== undefined && obj[key] !== null) {
        if (Array.isArray(obj[key])) {
          return obj[key];
        } else if (typeof obj[key] === 'string' && obj[key].trim()) {
          if (obj[key].includes(',')) {
            return obj[key].split(',').map(s => s.trim()).filter(s => s);
          }
          return [obj[key]];
        }
      }
    }
    return [];
  };

  const formatMonthDisplay = (monthStr) => {
    if (!monthStr) return 'N/A';
    const [year, month] = monthStr.split('-');
    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return `${monthNames[parseInt(month) - 1]} ${year}`;
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    });
  };

  const handleTrainingDateChange = async (applicationId, field, value) => {
    setUpdatingTrainingDates(prev => ({
      ...prev,
      [applicationId]: true
    }));

    setTrainingDates(prev => ({
      ...prev,
      [applicationId]: {
        ...(prev[applicationId] || {}),
        [field]: value
      }
    }));

    const savedDates = JSON.parse(localStorage.getItem('trainingDates') || '{}');
    savedDates[applicationId] = {
      ...(savedDates[applicationId] || {}),
      [field]: value
    };
    localStorage.setItem('trainingDates', JSON.stringify(savedDates));

    try {
      const token = localStorage.getItem('token');
      const currentDates = savedDates[applicationId] || {};
      const payload = {
        training_join_date: currentDates.joining_date || null,
        training_end_date: currentDates.ending_date || null
      };

      const response = await fetch(`${API_BASE_URL}/api/applications/${applicationId}/training`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(payload)
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update training dates');
      }
    } catch (err) {
      console.error('Error updating training dates:', err);
      alert(`Failed to update training dates: ${err.message || 'Please try again.'}`);
    } finally {
      setUpdatingTrainingDates(prev => ({
        ...prev,
        [applicationId]: false
      }));
    }
  };

  const handleUpdateDocumentsStatus = async (applicationId, newStatus) => {
    try {
      setUpdatingDocStatus(applicationId);
      const token = localStorage.getItem('token');

      const response = await fetch(`${API_BASE_URL}/api/applications/${applicationId}/documents`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ documents_status: newStatus })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Failed to update documents status');
      }

      if (selectedRequirement) {
        await fetchApplicationsForRequirement(selectedRequirement.id);
      }

      if (selectedApplication && selectedApplication.id === applicationId) {
        setSelectedApplication({
          ...selectedApplication,
          documents_status: newStatus
        });
      }

      const statusLabels = {
        'submitted': 'Submitted',
        'partially_submitted': 'Partially Submitted',
        'not_submitted': 'Not Submitted'
      };

      alert(`Documents status updated to: ${statusLabels[newStatus] || newStatus}`);
    } catch (err) {
      console.error('Error updating documents status:', err);
      alert(`Failed to update documents status: ${err.message || 'Please try again.'}`);
    } finally {
      setUpdatingDocStatus(null);
    }
  };

  const handleViewJoinedForm = async (application) => {
    setSelectedApplication(application);
    setLoadingFormView(true);
    setShowFormViewModal(true);

    try {
      const token = localStorage.getItem('token');
      const response = await fetch(`${API_BASE_URL}/api/applications/${application.id}/joined-form`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!response.ok) {
        throw new Error('Failed to fetch form data');
      }

      const result = await response.json();
      const data = result.data || result;
      setFormViewData(data);

    } catch (err) {
      console.error('Error fetching form:', err);
      alert('Failed to load application form. Please try again.');
    } finally {
      setLoadingFormView(false);
    }
  };

  const fetchApplicationsForRequirement = async (requirementId) => {
    setLoadingApps(true);
    setError('');
    try {
      const params = {
        requirement_id: requirementId,
        page: 1,
        limit: 10000,
      };

      if (searchTerm && searchTerm.trim() !== '') {
        params.search = searchTerm.trim();
      }

      if (filterStatus !== 'all') {
        params.status = filterStatus;
      }

      if (filters.education) {
        params.education = filters.education;
      }

      if (filters.preferred_location) {
        params.preferred_location = filters.preferred_location;
      }

      if (filters.notice_period) {
        params.notice_period = filters.notice_period;
      }

      if (filters.applied_date) {
        params.applied_date = filters.applied_date;
      }

      const response = await applicationApi.list(params);
      const data = response.data.data || response.data;
      const items = data.items || [];

      if (items.length === 0) {
        setApplications([]);
        setLoadingApps(false);
        return;
      }

      const detailedApps = await Promise.all(
        items.map(async (app) => {
          try {
            const detailResponse = await applicationApi.get(app.id);
            const detailData = detailResponse.data.data || detailResponse.data;

            const profile = detailData.candidate_profile ||
              detailData.profile ||
              detailData.candidate ||
              detailData.user ||
              {};

            const education = getFieldValue(
              profile,
              ['education', 'candidate_education', 'qualification', 'degree', 'highest_education'],
              getFieldValue(
                detailData,
                ['education', 'candidate_education', 'qualification'],
                getFieldValue(app, ['education'], 'N/A')
              )
            );

            let skills = getSkillsArray(
              profile,
              ['skills', 'candidate_skills', 'skill_set', 'technical_skills', 'skill']
            );
            if (skills.length === 0) {
              skills = getSkillsArray(detailData, ['skills', 'candidate_skills', 'skill_set']);
            }
            if (skills.length === 0) {
              skills = getSkillsArray(app, ['skills']);
            }

            const experience_years = getFieldValue(
              profile,
              ['experience_years', 'total_experience', 'years_of_experience', 'experience', 'work_experience'],
              getFieldValue(
                detailData,
                ['experience_years', 'total_experience', 'experience'],
                getFieldValue(app, ['experience_years', 'experience'], 'N/A')
              )
            );

            const preferred_location = getFieldValue(
              profile,
              ['preferred_location', 'location_preference', 'desired_location', 'preferred_city'],
              getFieldValue(
                detailData,
                ['preferred_location', 'location_preference'],
                getFieldValue(app, ['preferred_location', 'location'], 'N/A')
              )
            );

            const location = getFieldValue(
              profile,
              ['location', 'current_location', 'city', 'current_city'],
              getFieldValue(
                detailData,
                ['location', 'current_location'],
                getFieldValue(app, ['location', 'current_location'], 'N/A')
              )
            );

            const department = getFieldValue(
              profile,
              ['department', 'candidate_department', 'dept', 'functional_area'],
              getFieldValue(
                detailData,
                ['department', 'candidate_department'],
                getFieldValue(app, ['department'], 'N/A')
              )
            );

            const notice_period_days = getFieldValue(
              profile,
              ['notice_period_days', 'notice_period', 'notice_days', 'notice_period_in_days'],
              getFieldValue(
                detailData,
                ['notice_period_days', 'notice_period'],
                getFieldValue(app, ['notice_period_days', 'notice_period'], 'N/A')
              )
            );

            const current_company = getFieldValue(
              profile,
              ['current_company', 'company', 'employer', 'current_employer'],
              getFieldValue(
                detailData,
                ['current_company', 'company'],
                getFieldValue(app, ['current_company', 'company'], 'N/A')
              )
            );

            const current_salary = getFieldValue(
              profile,
              ['current_salary', 'salary', 'ctc', 'current_ctc'],
              getFieldValue(
                detailData,
                ['current_salary', 'salary'],
                getFieldValue(app, ['current_salary', 'salary'], null)
              )
            );

            const expected_salary = getFieldValue(
              profile,
              ['expected_salary', 'expected_ctc', 'expected_salary_lpa', 'desired_salary'],
              getFieldValue(
                detailData,
                ['expected_salary', 'expected_ctc'],
                getFieldValue(app, ['expected_salary', 'expected_ctc'], null)
              )
            );

            const linkedin_url = getFieldValue(
              profile,
              ['linkedin_url', 'linkedin', 'social_linkedin', 'linkedin_profile'],
              getFieldValue(
                detailData,
                ['linkedin_url', 'linkedin'],
                getFieldValue(app, ['linkedin_url', 'linkedin'], null)
              )
            );

            const candidate_name = getFieldValue(
              profile,
              ['name', 'candidate_name', 'full_name', 'fullname', 'user_name'],
              getFieldValue(
                detailData,
                ['candidate_name', 'name'],
                getFieldValue(app, ['candidate_name', 'name'], 'Unknown')
              )
            );

            const candidate_email = getFieldValue(
              profile,
              ['email', 'candidate_email', 'email_address', 'primary_email'],
              getFieldValue(
                detailData,
                ['candidate_email', 'email'],
                getFieldValue(app, ['candidate_email', 'email'], 'N/A')
              )
            );

            const candidate_mobile = getFieldValue(
              profile,
              ['mobile', 'candidate_mobile', 'phone', 'phone_number', 'contact_number'],
              getFieldValue(
                detailData,
                ['candidate_mobile', 'mobile'],
                getFieldValue(app, ['candidate_mobile', 'mobile'], 'N/A')
              )
            );

            const applied_at = detailData.applied_at || app.applied_at || detailData.created_at || app.created_at;
            const documents_status = detailData.documents_status || app.documents_status || 'not_submitted';
            const training_join_date = detailData.training_join_date || app.training_join_date || null;
            const training_end_date = detailData.training_end_date || app.training_end_date || null;
            const payment_details = detailData.salary_payments || detailData.training_stipends || [];

            return {
              id: detailData.id || app.id,
              candidate_id: detailData.candidate_id || app.candidate_id,
              requirement_id: detailData.requirement_id || app.requirement_id,
              status: detailData.status || app.status || 'applied',
              applied_at: applied_at,
              created_at: detailData.created_at || app.created_at,
              updated_at: detailData.updated_at || app.updated_at,
              documents_status: documents_status,
              training_join_date: training_join_date,
              training_end_date: training_end_date,
              payment_details: payment_details,
              documents_submitted_to_client: detailData.documents_submitted_to_client || app.documents_submitted_to_client || false,
              candidate_profile: profile,
              candidate_name: candidate_name,
              candidate_email: candidate_email,
              candidate_mobile: candidate_mobile,
              education: education,
              skills: skills,
              experience_years: experience_years,
              preferred_location: preferred_location,
              location: location,
              department: department,
              notice_period_days: notice_period_days,
              current_company: current_company,
              current_salary: current_salary,
              expected_salary: expected_salary,
              linkedin_url: linkedin_url,
              resume_url: detailData.resume_url || app.resume_url || profile.resume_url || null,
              resume_key: detailData.resume_key || app.resume_key || profile.resume_key || null,
              resume_filename: detailData.resume_filename || app.resume_filename || profile.resume_filename || null,
              notes: detailData.notes || app.notes || null,
              answers: detailData.answers || app.answers || []
            };

          } catch (err) {
            console.error(`Error fetching detail for app ${app.id}:`, err);
            return {
              ...app,
              candidate_profile: {},
              candidate_name: app.candidate_name || 'Unknown',
              candidate_email: app.candidate_email || 'N/A',
              candidate_mobile: app.candidate_mobile || 'N/A',
              education: app.education || 'N/A',
              skills: app.skills || [],
              experience_years: app.experience_years || 'N/A',
              preferred_location: app.preferred_location || 'N/A',
              location: app.location || 'N/A',
              department: app.department || 'N/A',
              notice_period_days: app.notice_period_days || 'N/A',
              current_company: app.current_company || 'N/A',
              current_salary: app.current_salary || null,
              expected_salary: app.expected_salary || null,
              linkedin_url: app.linkedin_url || null,
              resume_url: app.resume_url || null,
              resume_key: app.resume_key || null,
              resume_filename: app.resume_filename || null,
              notes: app.notes || null,
              answers: app.answers || [],
              documents_status: app.documents_status || 'not_submitted',
              training_join_date: app.training_join_date || null,
              training_end_date: app.training_end_date || null,
              payment_details: app.payment_details || [],
              documents_submitted_to_client: app.documents_submitted_to_client || false
            };
          }
        })
      );

      setApplications(detailedApps);
      setSelectedCandidates([]);
      setSelectAll(false);
      setSelectedJoinedCandidates([]);
      setSelectAllJoined(false);

    } catch (err) {
      console.error('Error fetching applications:', err);
      setError('Failed to load applications. Please try again.');
    } finally {
      setLoadingApps(false);
    }
  };

  const handleRequirementClick = async (requirement) => {
    setSelectedRequirement(requirement);
    setApplications([]);
    setFilterStatus('all');
    setSearchTerm('');
    setSelectedCandidates([]);
    setSelectAll(false);
    setSelectedJoinedCandidates([]);
    setSelectAllJoined(false);
    setActiveTab('applications');
    setTrainingSearchTerm('');
    setTrainingFilters({ education: '', preferred_location: '', notice_period: '' });
    setJoinedSearchTerm('');
    setJoinedFilters({ education: '', preferred_location: '', notice_period: '' });
    setSelectedTrainingCandidates([]);
    setSelectAllTraining(false);
    await fetchApplicationsForRequirement(requirement.id);
  };

  const getStatusBadge = (status) => {
    const statusMap = {
      'applied': { class: 'app-status-applied', label: 'Applied', icon: 'fa-clock' },
      'shortlisted': { class: 'app-status-shortlisted', label: 'Shortlisted', icon: 'fa-star' },
      'interview': { class: 'app-status-interview', label: 'Interview', icon: 'fa-handshake' },
      'offered': { class: 'app-status-offered', label: 'Offered', icon: 'fa-gift' },
      'training': { class: 'app-status-training', label: 'Training', icon: 'fa-graduation-cap' },
      'joined': { class: 'app-status-joined', label: 'Joined', icon: 'fa-user-check' },
      'rejected': { class: 'app-status-rejected', label: 'Rejected', icon: 'fa-times-circle' },
      'withdrawn': { class: 'app-status-withdrawn', label: 'Withdrawn', icon: 'fa-undo' },
    };
    const s = statusMap[status?.toLowerCase()] || statusMap['applied'];
    return (
      <span className={`app-status-badge ${s.class}`}>
        <i className={`fas ${s.icon}`}></i> {s.label}
      </span>
    );
  };

  const getDocumentsStatusDisplay = (status) => {
    if (status === 'submitted') {
      return (
        <span className="documents-status-badge status-submitted">
          <i className="fas fa-check-circle"></i> Yes
        </span>
      );
    } else {
      return (
        <span className="documents-status-badge status-pending">
          <i className="fas fa-times-circle"></i> No
        </span>
      );
    }
  };

  const handleSelectCandidate = (appId) => {
    setSelectedCandidates(prev => {
      if (prev.includes(appId)) {
        return prev.filter(id => id !== appId);
      } else {
        return [...prev, appId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedCandidates([]);
    } else {
      const allIds = filteredApplications.map(app => app.id);
      setSelectedCandidates(allIds);
    }
    setSelectAll(!selectAll);
  };

  const getSelectedCandidatesData = () => {
    return filteredApplications.filter(app => selectedCandidates.includes(app.id));
  };

  const handleSelectTrainingCandidate = (appId) => {
    setSelectedTrainingCandidates(prev => {
      if (prev.includes(appId)) {
        return prev.filter(id => id !== appId);
      } else {
        return [...prev, appId];
      }
    });
  };

  const handleSelectAllTraining = () => {
    if (selectAllTraining) {
      setSelectedTrainingCandidates([]);
    } else {
      const allIds = filteredTrainingList.map(app => app.id);
      setSelectedTrainingCandidates(allIds);
    }
    setSelectAllTraining(!selectAllTraining);
  };

  const getSelectedTrainingData = () => {
    return filteredTrainingList.filter(app => selectedTrainingCandidates.includes(app.id));
  };

  const handleSelectJoinedCandidate = (appId) => {
    setSelectedJoinedCandidates(prev => {
      if (prev.includes(appId)) {
        return prev.filter(id => id !== appId);
      } else {
        return [...prev, appId];
      }
    });
  };

  const handleSelectAllJoined = () => {
    if (selectAllJoined) {
      setSelectedJoinedCandidates([]);
    } else {
      const allIds = filteredJoinedList.map(app => app.id);
      setSelectedJoinedCandidates(allIds);
    }
    setSelectAllJoined(!selectAllJoined);
  };

  const getSelectedJoinedData = () => {
    return filteredJoinedList.filter(app => selectedJoinedCandidates.includes(app.id));
  };

  const handleBulkTraining = async () => {
    const selected = getSelectedCandidatesData();
    if (selected.length === 0) {
      alert('Please select at least one candidate');
      return;
    }

    const alreadyProcessed = selected.filter(app =>
      app.status === 'training' || app.status === 'joined'
    );
    if (alreadyProcessed.length > 0) {
      alert(`${alreadyProcessed.length} candidate(s) are already in Training or Joined. They will be skipped.`);
    }

    const confirmMove = window.confirm(
      `Bulk Move to Training\n\n` +
      `Candidates: ${selected.length}\n` +
      `Status will be changed to "Training"\n\n` +
      `Click OK to move all selected candidates to Training.`
    );

    if (!confirmMove) return;

    setSendingBulkTraining(true);
    setShowBulkTrainingModal(true);
    setBulkTrainingProgress({ current: 0, total: selected.length });

    let successCount = 0;
    let failCount = 0;
    const errors = [];
    const successfulCandidates = [];

    for (let i = 0; i < selected.length; i++) {
      const app = selected[i];
      setBulkTrainingProgress({ current: i + 1, total: selected.length });

      if (app.status === 'training' || app.status === 'joined') {
        continue;
      }

      try {
        await applicationApi.updateStatus(app.id, { status: 'training' });
        successCount++;
        successfulCandidates.push(app.candidate_name);
      } catch (err) {
        console.error(`Error moving ${app.candidate_name} to training:`, err);
        failCount++;
        errors.push(`${app.candidate_name || 'Unknown'}: ${err.message || 'Unknown error'}`);
      }

      await new Promise(resolve => setTimeout(resolve, 200));
    }

    setSendingBulkTraining(false);
    setShowBulkTrainingModal(false);

    if (selectedRequirement) {
      await fetchApplicationsForRequirement(selectedRequirement.id);
    }

    let summary = `Bulk Training Update!\n\n`;
    summary += `Success: ${successCount} candidate(s)\n`;
    if (failCount > 0) summary += `Failed: ${failCount} candidate(s)\n\n`;
    if (successfulCandidates.length > 0) {
      summary += `Moved to Training:\n${successfulCandidates.map(name => `• ${name}`).join('\n')}\n\n`;
    }
    if (errors.length > 0) {
      summary += `Errors:\n${errors.map(e => `• ${e}`).join('\n')}`;
    }

    alert(summary);
    setSelectedCandidates([]);
    setSelectAll(false);
  };

  const handleBulkJoined = async () => {
    const selected = getSelectedCandidatesData();
    if (selected.length === 0) {
      alert('Please select at least one candidate');
      return;
    }

    const alreadyJoined = selected.filter(app => app.status === 'joined');
    if (alreadyJoined.length > 0) {
      alert(`${alreadyJoined.length} candidate(s) are already in Joined. They will be skipped.`);
    }

    const confirmMove = window.confirm(
      `Bulk Move to Joined\n\n` +
      `Candidates: ${selected.length}\n` +
      `Status will be changed to "Joined"\n\n` +
      `Click OK to move all selected candidates to Joined.`
    );

    if (!confirmMove) return;

    setSendingBulkJoined(true);
    setShowBulkJoinedModal(true);
    setBulkJoinedProgress({ current: 0, total: selected.length });

    let successCount = 0;
    let failCount = 0;
    const errors = [];
    const successfulCandidates = [];

    for (let i = 0; i < selected.length; i++) {
      const app = selected[i];
      setBulkJoinedProgress({ current: i + 1, total: selected.length });

      if (app.status === 'joined') {
        continue;
      }

      try {
        await applicationApi.updateStatus(app.id, { status: 'joined' });
        successCount++;
        successfulCandidates.push(app.candidate_name);
      } catch (err) {
        console.error(`Error moving ${app.candidate_name} to joined:`, err);
        failCount++;
        errors.push(`${app.candidate_name || 'Unknown'}: ${err.message || 'Unknown error'}`);
      }

      await new Promise(resolve => setTimeout(resolve, 200));
    }

    setSendingBulkJoined(false);
    setShowBulkJoinedModal(false);

    if (selectedRequirement) {
      await fetchApplicationsForRequirement(selectedRequirement.id);
    }

    let summary = `Bulk Joined Update!\n\n`;
    summary += `Success: ${successCount} candidate(s)\n`;
    if (failCount > 0) summary += `Failed: ${failCount} candidate(s)\n\n`;
    if (successfulCandidates.length > 0) {
      summary += `Moved to Joined:\n${successfulCandidates.map(name => `• ${name}`).join('\n')}\n\n`;
    }
    if (errors.length > 0) {
      summary += `Errors:\n${errors.map(e => `• ${e}`).join('\n')}`;
    }

    alert(summary);
    setSelectedCandidates([]);
    setSelectAll(false);
  };

  const handleBulkJoinedFromTraining = async () => {
    const selected = getSelectedTrainingData();
    if (selected.length === 0) {
      alert('Please select at least one candidate');
      return;
    }

    const confirmMove = window.confirm(
      `Bulk Move to Joined\n\n` +
      `Candidates: ${selected.length}\n` +
      `Status will be changed to "Joined"\n\n` +
      `Click OK to move all selected candidates to Joined.`
    );

    if (!confirmMove) return;

    setSendingBulkJoined(true);
    setShowBulkJoinedModal(true);
    setBulkJoinedProgress({ current: 0, total: selected.length });

    let successCount = 0;
    let failCount = 0;
    const errors = [];
    const successfulCandidates = [];

    for (let i = 0; i < selected.length; i++) {
      const app = selected[i];
      setBulkJoinedProgress({ current: i + 1, total: selected.length });

      try {
        await applicationApi.updateStatus(app.id, { status: 'joined' });
        successCount++;
        successfulCandidates.push(app.candidate_name);
      } catch (err) {
        console.error(`Error moving ${app.candidate_name} to joined:`, err);
        failCount++;
        errors.push(`${app.candidate_name || 'Unknown'}: ${err.message || 'Unknown error'}`);
      }

      await new Promise(resolve => setTimeout(resolve, 200));
    }

    setSendingBulkJoined(false);
    setShowBulkJoinedModal(false);

    if (selectedRequirement) {
      await fetchApplicationsForRequirement(selectedRequirement.id);
    }

    let summary = `Bulk Joined Update!\n\n`;
    summary += `Success: ${successCount} candidate(s)\n`;
    if (failCount > 0) summary += `Failed: ${failCount} candidate(s)\n\n`;
    if (successfulCandidates.length > 0) {
      summary += `Moved to Joined:\n${successfulCandidates.map(name => `• ${name}`).join('\n')}\n\n`;
    }
    if (errors.length > 0) {
      summary += `Errors:\n${errors.map(e => `• ${e}`).join('\n')}`;
    }

    alert(summary);
    setSelectedTrainingCandidates([]);
    setSelectAllTraining(false);
  };

  const handleBroadcastWhatsApp = () => {
    const selected = getSelectedCandidatesData();
    if (selected.length === 0) {
      alert('Please select at least one candidate');
      return;
    }

    const withoutMobile = selected.filter(app => !app.candidate_mobile);
    if (withoutMobile.length > 0) {
      alert(`${withoutMobile.length} candidate(s) don't have mobile numbers:\n${withoutMobile.map(app => `• ${app.candidate_name}`).join('\n')}`);
      return;
    }

    setBroadcastMessage('');
    setShowBroadcastModal(true);
  };

  const sendBroadcastMessages = async () => {
    if (!broadcastMessage.trim()) {
      alert('Please enter a message to send');
      return;
    }

    const selected = getSelectedCandidatesData();
    if (selected.length === 0) {
      alert('No candidates selected');
      return;
    }

    const confirmSend = window.confirm(
      `Broadcast WhatsApp Message\n\n` +
      `Message:\n"${broadcastMessage}"\n\n` +
      `Recipients: ${selected.length} candidates\n` +
      `Each will receive this message separately\n\n` +
      `Click OK to send to all.`
    );

    if (!confirmSend) return;

    setSendingBroadcast(true);
    setBroadcastProgress({ current: 0, total: selected.length });

    const userRole = localStorage.getItem('userRole') || 'admin';
    const userName = localStorage.getItem('userName') || 'Admin';
    const token = localStorage.getItem('token');

    let successCount = 0;
    let failCount = 0;
    const errors = [];
    const successfulRecipients = [];

    for (let i = 0; i < selected.length; i++) {
      const app = selected[i];
      setBroadcastProgress({ current: i + 1, total: selected.length });

      if (!app.candidate_mobile) {
        failCount++;
        errors.push(`${app.candidate_name || 'Unknown'}: No mobile number`);
        continue;
      }

      let personalizedMessage = broadcastMessage;
      personalizedMessage = personalizedMessage.replace(/{{name}}/g, app.candidate_name || 'Candidate');
      personalizedMessage = personalizedMessage.replace(/{{position}}/g, selectedRequirement?.title || 'position');

      const payload = {
        message: personalizedMessage,
        channel: 'whatsapp',
        application_id: app.id || null,
        recipient_user_id: app.candidate_id || app.id || null,
        mobile_override: app.candidate_mobile || null,
        email_override: app.candidate_email || null,
        subject: `Message from ${userName} to ${app.candidate_name}`,
        sender_name: userName,
        sender_role: userRole
      };

      try {
        const response = await fetch(`${API_BASE_URL}/api/communications/send`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        });

        const result = await response.json();

        if (result.success) {
          successCount++;
          successfulRecipients.push(app.candidate_name);

          const savedMessages = localStorage.getItem('communication_messages');
          const messages = savedMessages ? JSON.parse(savedMessages) : [];
          const newMsg = {
            id: Date.now() + successCount,
            message: personalizedMessage,
            sent_by: userRole,
            recipient_user_id: app.candidate_id || app.id,
            application_id: app.id,
            created_at: new Date().toISOString(),
            status: 'sent',
            read: true,
            channel: 'whatsapp_broadcast',
            mobile: app.candidate_mobile,
            sender_name: userName,
            recipient_name: app.candidate_name,
            broadcast: true,
            broadcast_id: Date.now()
          };
          messages.push(newMsg);
          localStorage.setItem('communication_messages', JSON.stringify(messages));
        } else {
          failCount++;
          errors.push(`${app.candidate_name || 'Unknown'}: ${result.message || 'Unknown error'}`);
        }
      } catch (err) {
        console.error(`Error sending to ${app.candidate_name}:`, err);
        failCount++;
        errors.push(`${app.candidate_name || 'Unknown'}: ${err.message || 'Network error'}`);
      }

      await new Promise(resolve => setTimeout(resolve, 300));
    }

    setSendingBroadcast(false);
    setShowBroadcastModal(false);

    let summary = `Broadcast Message Sent!\n\n`;
    summary += `Success: ${successCount} candidate(s)\n`;
    summary += `Failed: ${failCount} candidate(s)\n\n`;

    if (successfulRecipients.length > 0) {
      summary += `Sent to:\n${successfulRecipients.map(name => `• ${name}`).join('\n')}\n\n`;
    }

    if (errors.length > 0) {
      summary += `Errors:\n${errors.map(e => `• ${e}`).join('\n')}`;
    }

    alert(summary);

    if (successCount === selected.length) {
      setSelectedCandidates([]);
      setSelectAll(false);
    }
  };

  const handlePayment = (candidate) => {
    setSelectedPaymentCandidate(candidate);
    setShowPaymentPopup(true);
  };

  const handlePaymentSubmit = (paymentData) => {
    const savedPayments = JSON.parse(localStorage.getItem('paymentHistory') || '[]');
    savedPayments.push(paymentData);
    localStorage.setItem('paymentHistory', JSON.stringify(savedPayments));
    setPaymentHistory(savedPayments);

    if (selectedRequirement) {
      fetchApplicationsForRequirement(selectedRequirement.id);
    }
  };

  const handleBulkPaymentJoined = () => {
    if (selectedJoinedCandidates.length === 0) {
      alert('Please select at least one joined candidate');
      return;
    }
    setBulkCandidates(getSelectedJoinedData());
    setShowBulkPaymentPopup(true);
  };

  const handleBulkPaymentSubmit = (bulkData) => {
    const { candidates, paymentData } = bulkData;

    const savedPayments = JSON.parse(localStorage.getItem('paymentHistory') || '[]');

    candidates.forEach(candidate => {
      const payment = {
        candidate_id: candidate.id,
        candidate_name: candidate.candidate_name,
        ...paymentData
      };
      savedPayments.push(payment);
    });

    localStorage.setItem('paymentHistory', JSON.stringify(savedPayments));
    setPaymentHistory(savedPayments);

    setShowBulkPaymentPopup(false);
    setSelectedJoinedCandidates([]);
    setSelectAllJoined(false);

    if (selectedRequirement) {
      fetchApplicationsForRequirement(selectedRequirement.id);
    }
  };

  const handleExportData = () => {
    if (activeTab === 'applications') {
      exportApplications();
    } else if (activeTab === 'training') {
      exportTraining();
    } else if (activeTab === 'joined') {
      exportJoined();
    }
  };

  const exportApplications = () => {
    if (filteredApplications.length === 0) {
      alert('No applications to export');
      return;
    }

    try {
      setExportingData(true);

      const docStatusLabels = {
        'submitted': 'Yes',
        'partially_submitted': 'No',
        'not_submitted': 'No'
      };

      const exportData = filteredApplications.map((app, index) => {
        const answersStr = app.answers && app.answers.length > 0
          ? app.answers.map(a => `${a.field_name || 'Field'}: ${a.value || 'N/A'}`).join(' | ')
          : 'N/A';

        return {
          'Sr No': index + 1,
          'Candidate Name': app.candidate_name || 'Unknown',
          'Email': app.candidate_email || 'N/A',
          'Mobile': app.candidate_mobile || 'N/A',
          'Education': app.education || 'N/A',
          'Skills': Array.isArray(app.skills) ? app.skills.join(', ') : app.skills || 'N/A',
          'Experience': app.experience_years ? `${app.experience_years} years` : 'N/A',
          'Preferred Location': app.preferred_location || app.location || 'N/A',
          'Department': app.department || 'N/A',
          'Notice Period': app.notice_period_days ? `${app.notice_period_days} days` : 'N/A',
          'Current Company': app.current_company || 'N/A',
          'Current Salary': app.current_salary ? `₹${app.current_salary.toLocaleString()}` : 'N/A',
          'Expected Salary': app.expected_salary ? `₹${app.expected_salary.toLocaleString()}` : 'N/A',
          'Status': app.status || 'Applied',
          'Applied Date': app.applied_at ? new Date(app.applied_at).toLocaleDateString('en-IN') : 'N/A',
          'Documents Status': docStatusLabels[app.documents_status] || 'No',
          'Answers': answersStr,
          'Requirement': selectedRequirement?.title || 'N/A',
          'Requirement Code': selectedRequirement?.requirement_code || 'N/A'
        };
      });

      const headers = Object.keys(exportData[0]);
      const csvRows = [headers.join(',')];

      for (const row of exportData) {
        const values = headers.map(header => {
          const value = row[header] || '';
          if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csvRows.push(values.join(','));
      }

      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `Applications_${selectedRequirement?.requirement_code || 'export'}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert(`Exported ${exportData.length} applications successfully!`);

    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export. Please try again.');
    } finally {
      setExportingData(false);
    }
  };

  const exportTraining = () => {
    const trainingList = applications.filter(app => app.status === 'training');
    const filteredList = trainingList.filter(app => {
      if (trainingSearchTerm) {
        const searchLower = trainingSearchTerm.toLowerCase();
        return (app.candidate_name && app.candidate_name.toLowerCase().includes(searchLower)) ||
          (app.candidate_email && app.candidate_email.toLowerCase().includes(searchLower)) ||
          (app.candidate_mobile && app.candidate_mobile.includes(trainingSearchTerm));
      }
      return true;
    });

    if (filteredList.length === 0) {
      alert('No training candidates to export');
      return;
    }

    try {
      setExportingData(true);

      const docStatusLabels = {
        'submitted': 'Yes',
        'partially_submitted': 'No',
        'not_submitted': 'No'
      };

      const exportData = filteredList.map((app, index) => ({
        'Sr No': index + 1,
        'Candidate Name': app.candidate_name || 'Unknown',
        'Email': app.candidate_email || 'N/A',
        'Mobile': app.candidate_mobile || 'N/A',
        'Education': app.education || 'N/A',
        'Skills': Array.isArray(app.skills) ? app.skills.join(', ') : app.skills || 'N/A',
        'Experience': app.experience_years ? `${app.experience_years} years` : 'N/A',
        'Preferred Location': app.preferred_location || app.location || 'N/A',
        'Department': app.department || 'N/A',
        'Notice Period': app.notice_period_days ? `${app.notice_period_days} days` : 'N/A',
        'Current Company': app.current_company || 'N/A',
        'Current Salary': app.current_salary ? `₹${app.current_salary.toLocaleString()}` : 'N/A',
        'Expected Salary': app.expected_salary ? `₹${app.expected_salary.toLocaleString()}` : 'N/A',
        'Status': 'Training',
        'Training Joining Date': trainingDates[app.id]?.joining_date || app.training_join_date || 'N/A',
        'Training Ending Date': trainingDates[app.id]?.ending_date || app.training_end_date || 'N/A',
        'Documents Status': docStatusLabels[app.documents_status] || 'No',
        'Requirement': selectedRequirement?.title || 'N/A',
        'Requirement Code': selectedRequirement?.requirement_code || 'N/A'
      }));

      const headers = Object.keys(exportData[0]);
      const csvRows = [headers.join(',')];
      for (const row of exportData) {
        const values = headers.map(header => {
          const value = row[header] || '';
          if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csvRows.push(values.join(','));
      }

      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `Training_${selectedRequirement?.requirement_code || 'export'}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert(`Exported ${exportData.length} training candidates successfully!`);
    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export. Please try again.');
    } finally {
      setExportingData(false);
    }
  };

  const exportJoined = () => {
    const joinedList = applications.filter(app => app.status === 'joined');
    const filteredList = joinedList.filter(app => {
      if (joinedSearchTerm) {
        const searchLower = joinedSearchTerm.toLowerCase();
        return (app.candidate_name && app.candidate_name.toLowerCase().includes(searchLower)) ||
          (app.candidate_email && app.candidate_email.toLowerCase().includes(searchLower)) ||
          (app.candidate_mobile && app.candidate_mobile.includes(joinedSearchTerm));
      }
      return true;
    });

    if (filteredList.length === 0) {
      alert('No joined candidates to export');
      return;
    }

    try {
      setExportingData(true);

      const exportData = filteredList.map((app, index) => ({
        'Sr No': index + 1,
        'Candidate Name': app.candidate_name || 'Unknown',
        'Email': app.candidate_email || 'N/A',
        'Mobile': app.candidate_mobile || 'N/A',
        'Education': app.education || 'N/A',
        'Skills': Array.isArray(app.skills) ? app.skills.join(', ') : app.skills || 'N/A',
        'Experience': app.experience_years ? `${app.experience_years} years` : 'N/A',
        'Preferred Location': app.preferred_location || app.location || 'N/A',
        'Department': app.department || 'N/A',
        'Notice Period': app.notice_period_days ? `${app.notice_period_days} days` : 'N/A',
        'Current Company': app.current_company || 'N/A',
        'Current Salary': app.current_salary ? `₹${app.current_salary.toLocaleString()}` : 'N/A',
        'Expected Salary': app.expected_salary ? `₹${app.expected_salary.toLocaleString()}` : 'N/A',
        'Status': 'Joined',
        'Joined On': app.updated_at ? new Date(app.updated_at).toLocaleDateString('en-IN') : 'N/A',
        'Requirement': selectedRequirement?.title || 'N/A',
        'Requirement Code': selectedRequirement?.requirement_code || 'N/A'
      }));

      const headers = Object.keys(exportData[0]);
      const csvRows = [headers.join(',')];
      for (const row of exportData) {
        const values = headers.map(header => {
          const value = row[header] || '';
          if (typeof value === 'string' && (value.includes(',') || value.includes('"') || value.includes('\n'))) {
            return `"${value.replace(/"/g, '""')}"`;
          }
          return value;
        });
        csvRows.push(values.join(','));
      }

      const csvString = csvRows.join('\n');
      const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
      const link = document.createElement('a');
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', `Joined_${selectedRequirement?.requirement_code || 'export'}_${new Date().toISOString().split('T')[0]}.csv`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      alert(`Exported ${exportData.length} joined candidates successfully!`);
    } catch (error) {
      console.error('Export error:', error);
      alert('Failed to export. Please try again.');
    } finally {
      setExportingData(false);
    }
  };

  const handleViewMore = async (application) => {
    try {
      setLoading(true);

      const response = await applicationApi.get(application.id);
      const fullData = response.data.data || response.data;

      const paymentDetails = fullData.salary_payments || fullData.training_stipends || [];

      const groupedPayments = {};

      paymentDetails.forEach(p => {
        const month = p.stipend_month;
        if (!groupedPayments[month]) {
          groupedPayments[month] = {
            stipend_month: month,
            government_status: p.government_status || 'pending',
            government_date: p.government_date,
            candidate_status: p.candidate_status || 'pending',
            candidate_date: p.candidate_date,
            remark: p.remark || p.not_paid_reason || '',
            count: 0
          };
        }
        groupedPayments[month].count += 1;

        if (p.government_status === 'received') {
          groupedPayments[month].government_status = 'received';
          groupedPayments[month].government_date = p.government_date;
        }
        if (p.candidate_status === 'paid') {
          groupedPayments[month].candidate_status = 'paid';
          groupedPayments[month].candidate_date = p.candidate_date;
        }
      });

      const formattedPayments = Object.values(groupedPayments)
        .map(p => ({
          ...p,
          stipend_month_display: formatMonthDisplay(p.stipend_month),
          government_date_display: p.government_date ? formatDate(p.government_date) : 'N/A',
          candidate_date_display: p.candidate_date ? formatDate(p.candidate_date) : 'N/A',
          month_count: p.count > 1 ? `(${p.count} entries)` : ''
        }))
        .sort((a, b) => b.stipend_month.localeCompare(a.stipend_month));

      const mergedData = {
        ...fullData,
        candidate_name: application.candidate_name || fullData.candidate_name || fullData.name || 'Unknown',
        candidate_email: application.candidate_email || fullData.candidate_email || fullData.email || 'N/A',
        candidate_mobile: application.candidate_mobile || fullData.candidate_mobile || fullData.mobile || 'N/A',
        education: application.education || fullData.education || 'N/A',
        skills: application.skills || fullData.skills || [],
        experience_years: application.experience_years || fullData.experience_years || 'N/A',
        preferred_location: application.preferred_location || fullData.preferred_location || 'N/A',
        location: application.location || fullData.location || 'N/A',
        department: application.department || fullData.department || 'N/A',
        notice_period_days: application.notice_period_days || fullData.notice_period_days || 'N/A',
        current_company: application.current_company || fullData.current_company || 'N/A',
        current_salary: application.current_salary || fullData.current_salary || null,
        expected_salary: application.expected_salary || fullData.expected_salary || null,
        linkedin_url: application.linkedin_url || fullData.linkedin_url || null,
        resume_url: application.resume_url || fullData.resume_url || null,
        resume_key: application.resume_key || fullData.resume_key || null,
        resume_filename: application.resume_filename || fullData.resume_filename || null,
        documents_status: application.documents_status || fullData.documents_status || 'not_submitted',
        training_join_date: application.training_join_date || fullData.training_join_date || null,
        training_end_date: application.training_end_date || fullData.training_end_date || null,
        payment_details: formattedPayments,
        documents_submitted_to_client: application.documents_submitted_to_client || fullData.documents_submitted_to_client || false,
        candidate_profile: {
          ...(fullData.candidate_profile || {}),
          ...(application.candidate_profile || {}),
          name: application.candidate_name || fullData.candidate_profile?.name,
          email: application.candidate_email || fullData.candidate_profile?.email,
          mobile: application.candidate_mobile || fullData.candidate_profile?.mobile,
          education: application.education || fullData.candidate_profile?.education,
          skills: application.skills || fullData.candidate_profile?.skills,
          experience_years: application.experience_years || fullData.candidate_profile?.experience_years,
          preferred_location: application.preferred_location || fullData.candidate_profile?.preferred_location,
          location: application.location || fullData.candidate_profile?.location,
          department: application.department || fullData.candidate_profile?.department,
          notice_period_days: application.notice_period_days || fullData.candidate_profile?.notice_period_days,
          current_company: application.current_company || fullData.candidate_profile?.current_company,
          current_salary: application.current_salary || fullData.candidate_profile?.current_salary,
          expected_salary: application.expected_salary || fullData.candidate_profile?.expected_salary,
          linkedin_url: application.linkedin_url || fullData.candidate_profile?.linkedin_url,
          resume_url: application.resume_url || fullData.candidate_profile?.resume_url,
          resume_key: application.resume_key || fullData.candidate_profile?.resume_key,
          resume_filename: application.resume_filename || fullData.candidate_profile?.resume_filename,
        }
      };

      setSelectedApplication(mergedData);
      setShowModal(true);
    } catch (err) {
      console.error('Error fetching application details:', err);

      const fallbackData = {
        ...application,
        candidate_profile: {
          ...(application.candidate_profile || {}),
          name: application.candidate_name,
          email: application.candidate_email,
          mobile: application.candidate_mobile,
          education: application.education,
          skills: application.skills,
          experience_years: application.experience_years,
          preferred_location: application.preferred_location,
          location: application.location,
          department: application.department,
          notice_period_days: application.notice_period_days,
          current_company: application.current_company,
          current_salary: application.current_salary,
          expected_salary: application.expected_salary,
          linkedin_url: application.linkedin_url,
          resume_url: application.resume_url,
          resume_key: application.resume_key,
          resume_filename: application.resume_filename,
        },
        documents_status: application.documents_status || 'not_submitted',
        training_join_date: application.training_join_date || null,
        training_end_date: application.training_end_date || null,
        payment_details: application.payment_details || []
      };

      setSelectedApplication(fallbackData);
      setShowModal(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedApplication(null);
  };

  const handleViewResume = (application) => {
    const resumeUrl = application.resume_url ||
      application.candidate_profile?.resume_url ||
      null;

    const resumeKey = application.resume_key ||
      application.candidate_profile?.resume_key ||
      null;

    if (resumeUrl) {
      window.open(resumeUrl, '_blank');
      return;
    }

    if (resumeKey) {
      const downloadUrl = `${API_BASE_URL}/api/candidates/resume/download?key=${encodeURIComponent(resumeKey)}`;
      window.open(downloadUrl, '_blank');
      return;
    }

    alert('Resume not available for this candidate');
  };

  const handleDownloadResume = (application) => {
    const resumeUrl = application.resume_url ||
      application.candidate_profile?.resume_url ||
      null;

    const resumeKey = application.resume_key ||
      application.candidate_profile?.resume_key ||
      null;

    const resumeFilename = application.resume_filename ||
      application.candidate_profile?.resume_filename ||
      'resume.pdf';

    if (resumeUrl) {
      const link = document.createElement('a');
      link.href = resumeUrl;
      link.download = resumeFilename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      return;
    }

    if (resumeKey) {
      const downloadUrl = `${API_BASE_URL}/api/candidates/resume/download?key=${encodeURIComponent(resumeKey)}`;
      const token = localStorage.getItem('token');
      fetch(downloadUrl, {
        headers: { 'Authorization': `Bearer ${token}` }
      })
        .then(response => {
          if (!response.ok) {
            throw new Error('Failed to download resume');
          }
          return response.blob();
        })
        .then(blob => {
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = resumeFilename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(url);
        })
        .catch(err => {
          console.error('Error downloading resume:', err);
          alert('Failed to download resume. Please try again.');
        });
      return;
    }

    alert('Resume not available for this candidate');
  };

  const handleUpdateStatus = async (id, newStatus, documentsSubmitted = null) => {
    try {
      const payload = { status: newStatus };
      if (documentsSubmitted !== null) {
        payload.documents_submitted_to_client = documentsSubmitted;
      }
      await applicationApi.updateStatus(id, payload);
      if (selectedRequirement) {
        await fetchApplicationsForRequirement(selectedRequirement.id);
      }
      if (selectedApplication && selectedApplication.id === id) {
        setSelectedApplication({ ...selectedApplication, status: newStatus, documents_submitted_to_client: documentsSubmitted });
      }
    } catch (err) {
      console.error('Error updating status:', err);
      alert('Failed to update application status. Please try again.');
    }
  };

  const handleTraining = async (application) => {
    try {
      if (application.status === 'training') {
        alert('This candidate is already in Training');
        return;
      }
      await handleUpdateStatus(application.id, 'training');
      setActiveTab('training');
      alert(`${application.candidate_name} has been moved to Training`);
    } catch (err) {
      console.error('Error moving to training:', err);
      alert('Failed to add candidate to training. Please try again.');
    }
  };

  const handleJoined = async (application) => {
    try {
      if (application.status === 'joined') {
        alert('This candidate is already in Joined');
        return;
      }
      await handleUpdateStatus(application.id, 'joined');
      setActiveTab('joined');
      alert(`${application.candidate_name} has been moved to Joined`);
    } catch (err) {
      console.error('Error marking as joined:', err);
      alert('Failed to add candidate to joined. Please try again.');
    }
  };

  const handleSendWhatsApp = (application) => {
    if (!application.candidate_mobile) {
      alert('No mobile number available for this candidate');
      return;
    }

    const message = prompt(`Send WhatsApp message to ${application.candidate_name} (${application.candidate_mobile}):`);

    if (!message || !message.trim()) {
      return;
    }

    const userRole = localStorage.getItem('userRole') || 'admin';
    const userName = localStorage.getItem('userName') || 'Admin';
    const token = localStorage.getItem('token');

    const payload = {
      message: message.trim(),
      channel: 'whatsapp',
      application_id: application.id || null,
      recipient_user_id: application.candidate_id || application.id || null,
      mobile_override: application.candidate_mobile || null,
      email_override: application.candidate_email || null,
      subject: `Message from ${userName} to ${application.candidate_name}`,
      sender_name: userName,
      sender_role: userRole
    };

    const sendMessage = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/api/communications/send`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
          },
          body: JSON.stringify(payload)
        });

        const result = await response.json();

        if (result.success) {
          alert(`WhatsApp message sent successfully to ${application.candidate_name}`);

          const savedMessages = localStorage.getItem('communication_messages');
          const messages = savedMessages ? JSON.parse(savedMessages) : [];
          const newMsg = {
            id: Date.now(),
            message: message.trim(),
            sent_by: userRole,
            recipient_user_id: application.candidate_id || application.id,
            application_id: application.id,
            created_at: new Date().toISOString(),
            status: 'sent',
            read: true,
            channel: 'whatsapp',
            mobile: application.candidate_mobile,
            sender_name: userName,
            recipient_name: application.candidate_name
          };
          messages.push(newMsg);
          localStorage.setItem('communication_messages', JSON.stringify(messages));
        } else {
          alert(`Failed to send: ${result.message || 'Unknown error'}`);
        }
      } catch (err) {
        console.error('Error sending WhatsApp message:', err);
        alert('Could not send message. Please try again.');
      }
    };

    sendMessage();
  };

  const filteredApplications = applications.filter(app => {
    if (searchTerm) {
      const searchLower = searchTerm.toLowerCase();
      const matchesSearch = (
        (app.candidate_name && app.candidate_name.toLowerCase().includes(searchLower)) ||
        (app.candidate_email && app.candidate_email.toLowerCase().includes(searchLower)) ||
        (app.candidate_mobile && app.candidate_mobile.includes(searchTerm))
      );
      if (!matchesSearch) return false;
    }

    const profile = app.candidate_profile || {};

    if (filters.education) {
      const edu = profile.education || app.education || '';
      if (!edu.toLowerCase().includes(filters.education.toLowerCase())) {
        return false;
      }
    }

    if (filters.preferred_location) {
      const loc = profile.preferred_location || app.preferred_location || '';
      if (!loc.toLowerCase().includes(filters.preferred_location.toLowerCase())) {
        return false;
      }
    }

    if (filters.notice_period) {
      let notice = profile.notice_period_days || app.notice_period_days || null;
      if (typeof notice === 'string') {
        const match = notice.match(/\d+/);
        if (match) {
          notice = parseInt(match[0]);
        } else {
          notice = null;
        }
      }
      if (typeof notice === 'object' && notice !== null) {
        notice = notice.days || notice.notice_period_days || null;
      }
      if (notice !== null && notice !== undefined && notice !== '') {
        const filterValue = parseInt(filters.notice_period);
        if (notice > filterValue) {
          return false;
        }
      }
    }

    if (filters.applied_date) {
      const appliedDate = app.applied_at ? new Date(app.applied_at) : null;
      if (!appliedDate) return false;

      const now = new Date();
      const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
      const yesterday = new Date(today);
      yesterday.setDate(yesterday.getDate() - 1);

      switch (filters.applied_date) {
        case 'today':
          if (appliedDate < today) return false;
          break;
        case 'yesterday':
          if (appliedDate < yesterday || appliedDate >= today) return false;
          break;
        case 'last7': {
          const last7 = new Date(today);
          last7.setDate(last7.getDate() - 7);
          if (appliedDate < last7) return false;
          break;
        }
        case 'last15': {
          const last15 = new Date(today);
          last15.setDate(last15.getDate() - 15);
          if (appliedDate < last15) return false;
          break;
        }
        case 'last30': {
          const last30 = new Date(today);
          last30.setDate(last30.getDate() - 30);
          if (appliedDate < last30) return false;
          break;
        }
        case 'last60': {
          const last60 = new Date(today);
          last60.setDate(last60.getDate() - 60);
          if (appliedDate < last60) return false;
          break;
        }
        case 'last90': {
          const last90 = new Date(today);
          last90.setDate(last90.getDate() - 90);
          if (appliedDate < last90) return false;
          break;
        }
        default:
          break;
      }
    }

    return true;
  });

  const trainingList = applications.filter(app => app.status === 'training');
  const joinedList = applications.filter(app => app.status === 'joined');

  const filteredTrainingList = trainingList.filter(app => {
    if (trainingSearchTerm) {
      const searchLower = trainingSearchTerm.toLowerCase();
      const matchesSearch = (
        (app.candidate_name && app.candidate_name.toLowerCase().includes(searchLower)) ||
        (app.candidate_email && app.candidate_email.toLowerCase().includes(searchLower)) ||
        (app.candidate_mobile && app.candidate_mobile.includes(trainingSearchTerm))
      );
      if (!matchesSearch) return false;
    }

    const profile = app.candidate_profile || {};

    if (trainingFilters.education) {
      const edu = profile.education || app.education || '';
      if (!edu.toLowerCase().includes(trainingFilters.education.toLowerCase())) {
        return false;
      }
    }

    if (trainingFilters.preferred_location) {
      const loc = profile.preferred_location || app.preferred_location || '';
      if (!loc.toLowerCase().includes(trainingFilters.preferred_location.toLowerCase())) {
        return false;
      }
    }

    if (trainingFilters.notice_period) {
      let notice = profile.notice_period_days || app.notice_period_days || null;
      if (typeof notice === 'string') {
        const match = notice.match(/\d+/);
        if (match) {
          notice = parseInt(match[0]);
        } else {
          notice = null;
        }
      }
      if (typeof notice === 'object' && notice !== null) {
        notice = notice.days || notice.notice_period_days || null;
      }
      if (notice !== null && notice !== undefined && notice !== '') {
        const filterValue = parseInt(trainingFilters.notice_period);
        if (notice > filterValue) {
          return false;
        }
      }
    }

    return true;
  });

  const filteredJoinedList = joinedList.filter(app => {
    if (joinedSearchTerm) {
      const searchLower = joinedSearchTerm.toLowerCase();
      const matchesSearch = (
        (app.candidate_name && app.candidate_name.toLowerCase().includes(searchLower)) ||
        (app.candidate_email && app.candidate_email.toLowerCase().includes(searchLower)) ||
        (app.candidate_mobile && app.candidate_mobile.includes(joinedSearchTerm))
      );
      if (!matchesSearch) return false;
    }

    const profile = app.candidate_profile || {};

    if (joinedFilters.education) {
      const edu = profile.education || app.education || '';
      if (!edu.toLowerCase().includes(joinedFilters.education.toLowerCase())) {
        return false;
      }
    }

    if (joinedFilters.preferred_location) {
      const loc = profile.preferred_location || app.preferred_location || '';
      if (!loc.toLowerCase().includes(joinedFilters.preferred_location.toLowerCase())) {
        return false;
      }
    }

    if (joinedFilters.notice_period) {
      let notice = profile.notice_period_days || app.notice_period_days || null;
      if (typeof notice === 'string') {
        const match = notice.match(/\d+/);
        if (match) {
          notice = parseInt(match[0]);
        } else {
          notice = null;
        }
      }
      if (typeof notice === 'object' && notice !== null) {
        notice = notice.days || notice.notice_period_days || null;
      }
      if (notice !== null && notice !== undefined && notice !== '') {
        const filterValue = parseInt(joinedFilters.notice_period);
        if (notice > filterValue) {
          return false;
        }
      }
    }

    return true;
  });

  const getTrainingFilterOptions = (key) => {
    const options = new Set();
    trainingList.forEach(app => {
      const value = app.candidate_profile?.[key] || app[key];
      if (value) {
        if (Array.isArray(value)) {
          value.forEach(v => options.add(v));
        } else {
          options.add(value);
        }
      }
    });
    return Array.from(options).sort();
  };

  const getJoinedFilterOptions = (key) => {
    const options = new Set();
    joinedList.forEach(app => {
      const value = app.candidate_profile?.[key] || app[key];
      if (value) {
        if (Array.isArray(value)) {
          value.forEach(v => options.add(v));
        } else {
          options.add(value);
        }
      }
    });
    return Array.from(options).sort();
  };

  const renderApplicationsTab = () => {
    return (
      <>
        <div className="filters-top">
          <div className="search-bar">
            <i className="fas fa-search"></i>
            <input
              type="text"
              placeholder="Search by name, email or mobile..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
            {searchTerm && (
              <button className="search-clear" onClick={() => setSearchTerm('')}>
                <i className="fas fa-times"></i>
              </button>
            )}
          </div>

          <div className="advanced-filters">
            <div className="filter-group">
              <label>Education</label>
              <select
                value={filters.education}
                onChange={(e) => setFilters({ ...filters, education: e.target.value })}
                className="filter-select"
              >
                <option value="">All Education</option>
                {getFilterOptions('education').map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Preferred Location</label>
              <select
                value={filters.preferred_location}
                onChange={(e) => setFilters({ ...filters, preferred_location: e.target.value })}
                className="filter-select"
              >
                <option value="">All Locations</option>
                {getFilterOptions('preferred_location').map(opt => (
                  <option key={opt} value={opt}>{opt}</option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Notice Period (Days)</label>
              <select
                value={filters.notice_period}
                onChange={(e) => setFilters({ ...filters, notice_period: e.target.value })}
                className="filter-select"
              >
                {NOTICE_PERIOD_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>

            <div className="filter-group">
              <label>Applied Date</label>
              <select
                value={filters.applied_date}
                onChange={(e) => setFilters({ ...filters, applied_date: e.target.value })}
                className="filter-select"
              >
                {DATE_FILTER_OPTIONS.map(opt => (
                  <option key={opt.value} value={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
          </div>

          {Object.values(filters).some(v => v !== '') && (
            <button
              className="clear-filters-btn"
              onClick={() => setFilters({
                education: '',
                preferred_location: '',
                notice_period: '',
                applied_date: ''
              })}
            >
              <i className="fas fa-times"></i> Clear All Filters
            </button>
          )}
        </div>

        {loadingApps ? (
          <div className="app-loading">
            <div className="spinner"></div>
            <p>Loading applications...</p>
          </div>
        ) : (
          <div className="app-table-container">
            {filteredApplications.length === 0 ? (
              <div className="empty-apps">
                <i className="fas fa-search"></i>
                <p>No results found</p>
              </div>
            ) : (
              <>
                <div className="bulk-actions-toolbar">
                  <div className="bulk-select">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={handleSelectAll}
                      className="select-all-checkbox"
                    />
                    <label>
                      {selectAll ? 'Deselect All' : 'Select All'} ({filteredApplications.length})
                    </label>
                  </div>
                  <div className="bulk-actions">
                    <span className="selected-count">{selectedCandidates.length} selected</span>
                    {selectedCandidates.length > 0 && (
                      <>
                        <button className="btn-broadcast-whatsapp" onClick={handleBroadcastWhatsApp}>
                          <i className="fab fa-whatsapp"></i> Broadcast
                        </button>
                        <button className="btn-bulk-training" onClick={handleBulkTraining}>
                          <FontAwesomeIcon icon={faGraduationCap} /> Bulk Training
                        </button>
                        <button className="btn-bulk-joined" onClick={handleBulkJoined}>
                          <FontAwesomeIcon icon={faUserCheck} /> Bulk Joined
                        </button>
                      </>
                    )}
                  </div>
                </div>

                <table className="app-table">
                  <thead>
                    <tr>
                      <th className="col-select">
                        <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
                      </th>
                      <th>Candidate</th>
                      <th>Email</th>
                      <th>Mobile</th>
                      <th>Education</th>
                      <th>Location</th>
                      <th>Notice Period</th>
                      <th>Applied Date</th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filteredApplications.map((app) => (
                      <tr key={app.id}>
                        <td className="col-select">
                          <input
                            type="checkbox"
                            checked={selectedCandidates.includes(app.id)}
                            onChange={() => handleSelectCandidate(app.id)}
                          />
                        </td>
                        <td className="app-name">
                          <div className="app-name-cell">
                            <div className="mini-avatar">
                              {app.candidate_name?.split(' ').map(n => n[0]).join('') || 'U'}
                            </div>
                            <span>{app.candidate_name || 'Unknown'}</span>
                          </div>
                        </td>
                        <td>{app.candidate_email || 'N/A'}</td>
                        <td>{app.candidate_mobile || 'N/A'}</td>
                        <td>{app.education || 'N/A'}</td>
                        <td>{app.preferred_location || app.location || 'N/A'}</td>
                        <td>{app.notice_period_days ? `${app.notice_period_days} days` : 'N/A'}</td>
                        <td>{formatDate(app.applied_at)}</td>
                        <td>{getStatusBadge(app.status)}</td>
                        <td className="app-actions">
                          <button className="btn-whatsapp-table" onClick={() => handleSendWhatsApp(app)}>
                            <FontAwesomeIcon icon={faWhatsapp} />
                          </button>
                          <button className="btn-view-table" onClick={() => handleViewMore(app)}>
                            <FontAwesomeIcon icon={faEye} />
                          </button>
                          <button className="btn-resume-table" onClick={() => handleViewResume(app)}>
                            <FontAwesomeIcon icon={faFilePdf} />
                          </button>
                          {app.status !== 'training' && app.status !== 'joined' && app.status !== 'rejected' && app.status !== 'withdrawn' && (
                            <>
                              <button className="btn-training-table" onClick={() => handleTraining(app)}>
                                <FontAwesomeIcon icon={faGraduationCap} />
                              </button>
                              <button className="btn-joined-table" onClick={() => handleJoined(app)}>
                                <FontAwesomeIcon icon={faUserCheck} />
                              </button>
                            </>
                          )}
                          {app.status === 'training' && (
                            <button className="btn-joined-table" onClick={() => handleJoined(app)}>
                              <FontAwesomeIcon icon={faUserCheck} />
                            </button>
                          )}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        )}
      </>
    );
  };

  const renderTrainingTab = () => {
    return (
      <div className="list-container training-list">
        <div className="list-header">
          <div className="list-header-left">
            <h3><FontAwesomeIcon icon={faGraduationCap} style={{ color: '#8e44ad' }} /> Training List</h3>
            <span className="list-count">{filteredTrainingList.length} candidates</span>
          </div>
          <div className="list-header-actions">
            {selectedTrainingCandidates.length > 0 && (
              <button className="btn-bulk-joined-training" onClick={handleBulkJoinedFromTraining}>
                <FontAwesomeIcon icon={faUserCheck} /> Bulk Joined ({selectedTrainingCandidates.length})
              </button>
            )}
          </div>
        </div>

        {trainingList.length > 0 && (
          <div className="filters-top list-filters">
            <div className="search-bar">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Search by name, email or mobile..."
                value={trainingSearchTerm}
                onChange={(e) => setTrainingSearchTerm(e.target.value)}
                className="search-input"
              />
              {trainingSearchTerm && (
                <button className="search-clear" onClick={() => setTrainingSearchTerm('')}>
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>

            <div className="advanced-filters">
              <div className="filter-group">
                <label>Education</label>
                <select
                  value={trainingFilters.education}
                  onChange={(e) => setTrainingFilters({ ...trainingFilters, education: e.target.value })}
                  className="filter-select"
                >
                  <option value="">All Education</option>
                  {getTrainingFilterOptions('education').map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Preferred Location</label>
                <select
                  value={trainingFilters.preferred_location}
                  onChange={(e) => setTrainingFilters({ ...trainingFilters, preferred_location: e.target.value })}
                  className="filter-select"
                >
                  <option value="">All Locations</option>
                  {getTrainingFilterOptions('preferred_location').map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Notice Period (Days)</label>
                <select
                  value={trainingFilters.notice_period}
                  onChange={(e) => setTrainingFilters({ ...trainingFilters, notice_period: e.target.value })}
                  className="filter-select"
                >
                  {NOTICE_PERIOD_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {Object.values(trainingFilters).some(v => v !== '') && (
              <button
                className="clear-filters-btn"
                onClick={() => setTrainingFilters({
                  education: '',
                  preferred_location: '',
                  notice_period: '',
                })}
              >
                <i className="fas fa-times"></i> Clear All Filters
              </button>
            )}
          </div>
        )}

        {filteredTrainingList.length === 0 ? (
          <div className="empty-list">
            <i className="fas fa-users"></i>
            <p>{trainingList.length === 0 ? 'No candidates in training yet' : 'No results found'}</p>
          </div>
        ) : (
          <div className="list-table-container">
            <table className="list-table">
              <thead>
                <tr>
                  <th className="col-select">
                    <input type="checkbox" checked={selectAllTraining} onChange={handleSelectAllTraining} />
                  </th>
                  <th>#</th>
                  <th>Candidate</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Education</th>
                  <th>Experience</th>
                  <th>Location</th>
                  <th>Training Joining Date</th>
                  <th>Training Ending Date</th>
                  <th>Documents</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredTrainingList.map((app, index) => {
                  const joiningDate = trainingDates[app.id]?.joining_date || app.training_join_date || '';
                  const endingDate = trainingDates[app.id]?.ending_date || app.training_end_date || '';
                  const isUpdating = updatingTrainingDates[app.id];

                  return (
                    <tr key={app.id}>
                      <td className="col-select">
                        <input
                          type="checkbox"
                          checked={selectedTrainingCandidates.includes(app.id)}
                          onChange={() => handleSelectTrainingCandidate(app.id)}
                        />
                      </td>
                      <td>{index + 1}</td>
                      <td className="app-name">
                        <div className="app-name-cell">
                          <div className="mini-avatar">
                            {app.candidate_name?.split(' ').map(n => n[0]).join('') || 'U'}
                          </div>
                          <span>{app.candidate_name || 'Unknown'}</span>
                        </div>
                      </td>
                      <td>{app.candidate_email || 'N/A'}</td>
                      <td>{app.candidate_mobile || 'N/A'}</td>
                      <td>{app.education || 'N/A'}</td>
                      <td>{app.experience_years || 'N/A'} yrs</td>
                      <td>{app.preferred_location || app.location || 'N/A'}</td>
                      <td>
                        <div className="date-input-wrapper">
                          <input
                            type="date"
                            className={`date-input-training ${isUpdating ? 'updating' : ''}`}
                            value={joiningDate}
                            onChange={(e) => handleTrainingDateChange(app.id, 'joining_date', e.target.value)}
                            disabled={isUpdating}
                          />
                          {isUpdating && <span className="date-updating-spinner"><i className="fas fa-spinner fa-spin"></i></span>}
                        </div>
                      </td>
                      <td>
                        <div className="date-input-wrapper">
                          <input
                            type="date"
                            className={`date-input-training ${isUpdating ? 'updating' : ''}`}
                            value={endingDate}
                            onChange={(e) => handleTrainingDateChange(app.id, 'ending_date', e.target.value)}
                            disabled={isUpdating}
                          />
                          {isUpdating && <span className="date-updating-spinner"><i className="fas fa-spinner fa-spin"></i></span>}
                        </div>
                      </td>
                      <td>{getDocumentsStatusDisplay(app.documents_status || 'not_submitted')}</td>
                      <td className="app-actions">
                        <button className="btn-view-table" onClick={() => handleViewMore(app)}>
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                        <button className="btn-joined-table" onClick={() => handleJoined(app)}>
                          <FontAwesomeIcon icon={faUserCheck} />
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  const renderJoinedTab = () => {
    return (
      <div className="list-container joined-list">
        <div className="list-header">
          <div className="list-header-left">
            <h3><FontAwesomeIcon icon={faUserCheck} style={{ color: '#1e8449' }} /> Joined List</h3>
            <span className="list-count">{filteredJoinedList.length} candidates</span>
          </div>
          <div className="list-header-actions">
            {selectedJoinedCandidates.length > 0 && (
              <button className="btn-bulk-payment-joined" onClick={handleBulkPaymentJoined}>
                <FontAwesomeIcon icon={faMoneyBillWave} /> Bulk Payment ({selectedJoinedCandidates.length})
              </button>
            )}
          </div>
        </div>

        {joinedList.length > 0 && (
          <div className="filters-top list-filters">
            <div className="search-bar">
              <i className="fas fa-search"></i>
              <input
                type="text"
                placeholder="Search by name, email or mobile..."
                value={joinedSearchTerm}
                onChange={(e) => setJoinedSearchTerm(e.target.value)}
                className="search-input"
              />
              {joinedSearchTerm && (
                <button className="search-clear" onClick={() => setJoinedSearchTerm('')}>
                  <i className="fas fa-times"></i>
                </button>
              )}
            </div>

            <div className="advanced-filters">
              <div className="filter-group">
                <label>Education</label>
                <select
                  value={joinedFilters.education}
                  onChange={(e) => setJoinedFilters({ ...joinedFilters, education: e.target.value })}
                  className="filter-select"
                >
                  <option value="">All Education</option>
                  {getJoinedFilterOptions('education').map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Preferred Location</label>
                <select
                  value={joinedFilters.preferred_location}
                  onChange={(e) => setJoinedFilters({ ...joinedFilters, preferred_location: e.target.value })}
                  className="filter-select"
                >
                  <option value="">All Locations</option>
                  {getJoinedFilterOptions('preferred_location').map(opt => (
                    <option key={opt} value={opt}>{opt}</option>
                  ))}
                </select>
              </div>

              <div className="filter-group">
                <label>Notice Period (Days)</label>
                <select
                  value={joinedFilters.notice_period}
                  onChange={(e) => setJoinedFilters({ ...joinedFilters, notice_period: e.target.value })}
                  className="filter-select"
                >
                  {NOTICE_PERIOD_OPTIONS.map(opt => (
                    <option key={opt.value} value={opt.value}>
                      {opt.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {Object.values(joinedFilters).some(v => v !== '') && (
              <button
                className="clear-filters-btn"
                onClick={() => setJoinedFilters({
                  education: '',
                  preferred_location: '',
                  notice_period: '',
                })}
              >
                <i className="fas fa-times"></i> Clear All Filters
              </button>
            )}
          </div>
        )}

        {filteredJoinedList.length === 0 ? (
          <div className="empty-list">
            <i className="fas fa-users"></i>
            <p>{joinedList.length === 0 ? 'No candidates have joined yet' : 'No results found'}</p>
          </div>
        ) : (
          <div className="list-table-container">
            <table className="list-table">
              <thead>
                <tr>
                  <th className="col-select">
                    <input
                      type="checkbox"
                      checked={selectAllJoined}
                      onChange={handleSelectAllJoined}
                    />
                  </th>
                  <th>#</th>
                  <th>Candidate</th>
                  <th>Email</th>
                  <th>Mobile</th>
                  <th>Education</th>
                  <th>Experience</th>
                  <th>Location</th>
                  <th>Joined On</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {filteredJoinedList.map((app, index) => {
                  return (
                    <tr key={app.id}>
                      <td className="col-select">
                        <input
                          type="checkbox"
                          checked={selectedJoinedCandidates.includes(app.id)}
                          onChange={() => handleSelectJoinedCandidate(app.id)}
                        />
                      </td>
                      <td>{index + 1}</td>
                      <td className="app-name">
                        <div className="app-name-cell">
                          <div className="mini-avatar">
                            {app.candidate_name?.split(' ').map(n => n[0]).join('') || 'U'}
                          </div>
                          <span>{app.candidate_name || 'Unknown'}</span>
                        </div>
                      </td>
                      <td>{app.candidate_email || 'N/A'}</td>
                      <td>{app.candidate_mobile || 'N/A'}</td>
                      <td>{app.education || 'N/A'}</td>
                      <td>{app.experience_years || 'N/A'} yrs</td>
                      <td>{app.preferred_location || app.location || 'N/A'}</td>
                      <td>{formatDate(app.updated_at || app.created_at)}</td>
                      <td className="app-actions">
                        <button className="btn-view-table" onClick={() => handleViewMore(app)}>
                          <FontAwesomeIcon icon={faEye} />
                        </button>
                        <button className="btn-payment-table" onClick={() => handlePayment(app)}>
                          <FontAwesomeIcon icon={faMoneyBillWave} />
                        </button>
                        <button
                          className="btn-form-view"
                          onClick={() => handleViewJoinedForm(app)}
                          title="View Application Form"
                        >
                          <i className="fas fa-file-signature"></i>
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    );
  };

  if (loading) {
    return (
      <div className="app-loading">
        <div className="spinner"></div>
        <p>Loading requirements...</p>
      </div>
    );
  }

  return (
    <div className="app-container">
      <div className="app-header">
        <h1><i className="fas fa-users"></i> View Applications</h1>
      </div>

      {error && (
        <div className="error-message">
          <i className="fas fa-exclamation-circle"></i>
          <span>{error}</span>
        </div>
      )}

      <div className="requirements-section">
        <h2><i className="fas fa-list"></i> Select Requirement</h2>
        <div className="requirements-grid">
          {requirements.length === 0 ? (
            <div className="empty-requirements">
              <i className="fas fa-inbox"></i>
              <p>No requirements found</p>
            </div>
          ) : (
            requirements.map((req) => (
              <div
                key={req.id}
                className={`requirement-card ${selectedRequirement?.id === req.id ? 'active' : ''}`}
                onClick={() => handleRequirementClick(req)}
              >
                <div className="requirement-header">
                  <h3>{req.title || 'Untitled Requirement'}</h3>
                  <span className="requirement-code">{req.requirement_code || 'N/A'}</span>
                </div>
                <div className="requirement-body">
                  <div className="requirement-detail">
                    <i className="fas fa-building"></i>
                    <span>{req.department || 'N/A'}</span>
                  </div>
                  <div className="requirement-detail">
                    <i className="fas fa-map-marker-alt"></i>
                    <span>{req.location || 'N/A'}</span>
                  </div>
                </div>
                {selectedRequirement?.id === req.id && (
                  <div className="requirement-active-indicator">
                    <i className="fas fa-check-circle"></i> Selected
                  </div>
                )}
              </div>
            ))
          )}
        </div>
      </div>

      {selectedRequirement && (
        <div className="applications-section">
          <div className="applications-header">
            <h2>
              <i className="fas fa-user-graduate"></i>
              Candidates Applied for: {selectedRequirement.title}
            </h2>
            <div className="header-actions">
              <span className="total-apps">Total Applicants: {applications.length}</span>
              <button
                className="btn-export-sheet"
                onClick={handleExportData}
                disabled={
                  exportingData ||
                  (activeTab === 'applications' && filteredApplications.length === 0) ||
                  (activeTab === 'training' && filteredTrainingList.length === 0) ||
                  (activeTab === 'joined' && filteredJoinedList.length === 0)
                }
              >
                {exportingData ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i> Exporting...
                  </>
                ) : (
                  <>
                    <i className="fas fa-file-excel"></i> Export {activeTab === 'applications' ? 'Applications' : activeTab === 'training' ? 'Training' : 'Joined'}
                  </>
                )}
              </button>
            </div>
          </div>

          <div className="tab-system">
            <div className="tab-header">
              <button className={`tab-btn ${activeTab === 'applications' ? 'active' : ''}`} onClick={() => setActiveTab('applications')}>
                <FontAwesomeIcon icon={faList} /> Applications ({applications.length})
              </button>
              <button className={`tab-btn ${activeTab === 'training' ? 'active' : ''}`} onClick={() => setActiveTab('training')}>
                <FontAwesomeIcon icon={faGraduationCap} /> Training ({trainingList.length})
              </button>
              <button className={`tab-btn ${activeTab === 'joined' ? 'active' : ''}`} onClick={() => setActiveTab('joined')}>
                <FontAwesomeIcon icon={faUserCheck} /> Joined ({joinedList.length})
              </button>
            </div>

            <div className="tab-content">
              {activeTab === 'applications' && renderApplicationsTab()}
              {activeTab === 'training' && renderTrainingTab()}
              {activeTab === 'joined' && renderJoinedTab()}
            </div>
          </div>
        </div>
      )}

      <TrainingPaymentPopup
        isOpen={showPaymentPopup}
        onClose={() => {
          setShowPaymentPopup(false);
          setSelectedPaymentCandidate(null);
        }}
        candidate={selectedPaymentCandidate}
        onPaymentSubmit={handlePaymentSubmit}
      />

      <TrainingPaymentPopup
        isOpen={showBulkPaymentPopup}
        onClose={() => {
          setShowBulkPaymentPopup(false);
          setBulkCandidates([]);
        }}
        isBulk={true}
        bulkCandidates={bulkCandidates}
        onBulkPaymentSubmit={handleBulkPaymentSubmit}
        onPaymentSubmit={handlePaymentSubmit}
      />

      {showBulkTrainingModal && (
        <div className="modal-overlay" onClick={() => setShowBulkTrainingModal(false)}>
          <div className="modal-content-app" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-app">
              <div className="modal-header-left">
                <h2><FontAwesomeIcon icon={faGraduationCap} style={{ color: '#8e44ad' }} /> Bulk Training Progress</h2>
                <p className="modal-subtitle">Moving candidates to Training...</p>
              </div>
            </div>
            <div className="modal-body-app">
              <div className="broadcast-progress">
                <div className="progress-circle">
                  <i className="fas fa-spinner fa-spin"></i>
                  <span>{bulkTrainingProgress.current}/{bulkTrainingProgress.total}</span>
                </div>
                <p>Processing candidates... Please wait</p>
                <div className="progress-bar">
                  <div className="progress-fill" style={{ width: `${(bulkTrainingProgress.current / bulkTrainingProgress.total) * 100}%` }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showBulkJoinedModal && (
        <div className="modal-overlay" onClick={() => setShowBulkJoinedModal(false)}>
          <div className="modal-content-app" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-app">
              <div className="modal-header-left">
                <h2><FontAwesomeIcon icon={faUserCheck} style={{ color: '#1e8449' }} /> Bulk Joined Progress</h2>
                <p className="modal-subtitle">Moving candidates to Joined...</p>
              </div>
            </div>
            <div className="modal-body-app">
              <div className="broadcast-progress">
                <div className="progress-circle">
                  <i className="fas fa-spinner fa-spin"></i>
                  <span>{bulkJoinedProgress.current}/{bulkJoinedProgress.total}</span>
                </div>
                <p>Processing candidates... Please wait</p>
                <div className="progress-bar">
                  <div className="progress-fill" style={{ width: `${(bulkJoinedProgress.current / bulkJoinedProgress.total) * 100}%` }}></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showBroadcastModal && (
        <div className="modal-overlay" onClick={() => setShowBroadcastModal(false)}>
          <div className="modal-content-app" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-app">
              <div className="modal-header-left">
                <h2><i className="fab fa-whatsapp" style={{ color: '#25D366' }}></i> Broadcast WhatsApp</h2>
                <p className="modal-subtitle">Send same message to {selectedCandidates.length} candidates separately</p>
              </div>
              <button className="modal-close-app" onClick={() => setShowBroadcastModal(false)}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="modal-body-app">
              {sendingBroadcast ? (
                <div className="broadcast-progress">
                  <div className="progress-circle">
                    <i className="fas fa-spinner fa-spin"></i>
                    <span>{broadcastProgress.current}/{broadcastProgress.total}</span>
                  </div>
                  <p>Sending messages... Please wait</p>
                  <div className="progress-bar">
                    <div className="progress-fill" style={{ width: `${(broadcastProgress.current / broadcastProgress.total) * 100}%` }}></div>
                  </div>
                </div>
              ) : (
                <>
                  <div className="broadcast-recipients">
                    <h4>Recipients ({selectedCandidates.length})</h4>
                    <div className="recipients-list">
                      {getSelectedCandidatesData().map((app, idx) => (
                        <div key={app.id} className="recipient-item">
                          <span className="recipient-number">{idx + 1}.</span>
                          <span className="recipient-name">{app.candidate_name || 'Unknown'}</span>
                          <span className="recipient-mobile">{app.candidate_mobile || 'No mobile'}</span>
                        </div>
                      ))}
                    </div>
                  </div>

                  <div className="broadcast-message-area">
                    <label>Message</label>
                    <div className="message-tips">
                      <small>Use <code>{'{{name}}'}</code> for candidate name, <code>{'{{position}}'}</code> for position</small>
                    </div>
                    <textarea
                      value={broadcastMessage}
                      onChange={(e) => setBroadcastMessage(e.target.value)}
                      placeholder="Type your message here... Use {{name}} for candidate name"
                      className="broadcast-textarea"
                      rows="6"
                    />
                    <div className="message-preview">
                      <small>Preview:</small>
                      <p className="preview-text">{broadcastMessage || 'Your message will appear here'}</p>
                    </div>
                  </div>

                  <div className="modal-actions-app">
                    <button className="btn-close-modal" onClick={() => setShowBroadcastModal(false)}>Cancel</button>
                    <button className="btn-broadcast-send" onClick={sendBroadcastMessages} disabled={!broadcastMessage.trim()}>
                      <i className="fab fa-whatsapp"></i> Send to All
                    </button>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {showModal && selectedApplication && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content-app" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header-app">
              <div className="modal-header-left">
                <div className="modal-avatar-lg">
                  {selectedApplication.candidate_name?.split(' ').map(n => n[0]).join('') || 'U'}
                </div>
                <div>
                  <h2>{selectedApplication.candidate_name || 'Unknown'}</h2>
                  <p className="modal-position">{selectedApplication.requirement_title || 'N/A'}</p>
                  {getStatusBadge(selectedApplication.status)}
                </div>
              </div>
              <button className="modal-close-app" onClick={handleCloseModal}>
                <i className="fas fa-times"></i>
              </button>
            </div>

            <div className="modal-body-app">
              <div className="modal-section profile-section">
                <h3><i className="fas fa-user-circle"></i> Candidate Profile</h3>
                <div className="modal-details-grid">
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-user"></i> Full Name</span>
                    <span className="modal-value">{selectedApplication.candidate_name || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-envelope"></i> Email</span>
                    <span className="modal-value">{selectedApplication.candidate_email || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-phone"></i> Mobile</span>
                    <span className="modal-value">{selectedApplication.candidate_mobile || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-calendar"></i> Applied Date</span>
                    <span className="modal-value">{formatDate(selectedApplication.applied_at)}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-map-marker-alt"></i> Current Location</span>
                    <span className="modal-value">{selectedApplication.location || selectedApplication.candidate_profile?.location || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-map-pin"></i> Preferred Location</span>
                    <span className="modal-value">{selectedApplication.preferred_location || selectedApplication.candidate_profile?.preferred_location || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-briefcase"></i> Experience</span>
                    <span className="modal-value">{selectedApplication.experience_years || selectedApplication.candidate_profile?.experience_years ? `${selectedApplication.experience_years || selectedApplication.candidate_profile?.experience_years} years` : 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-graduation-cap"></i> Education</span>
                    <span className="modal-value">{selectedApplication.education || selectedApplication.candidate_profile?.education || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-building"></i> Department</span>
                    <span className="modal-value">{selectedApplication.department || selectedApplication.candidate_profile?.department || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-company"></i> Current Company</span>
                    <span className="modal-value">{selectedApplication.current_company || selectedApplication.candidate_profile?.current_company || 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-money-bill"></i> Current Salary</span>
                    <span className="modal-value">{selectedApplication.current_salary || selectedApplication.candidate_profile?.current_salary ? `₹${(selectedApplication.current_salary || selectedApplication.candidate_profile?.current_salary).toLocaleString()}` : 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-money-bill-wave"></i> Expected Salary</span>
                    <span className="modal-value">{selectedApplication.expected_salary || selectedApplication.candidate_profile?.expected_salary ? `₹${(selectedApplication.expected_salary || selectedApplication.candidate_profile?.expected_salary).toLocaleString()}` : 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-clock"></i> Notice Period</span>
                    <span className="modal-value">{selectedApplication.notice_period_days || selectedApplication.candidate_profile?.notice_period_days ? `${selectedApplication.notice_period_days || selectedApplication.candidate_profile?.notice_period_days} days` : 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fab fa-linkedin"></i> LinkedIn</span>
                    <span className="modal-value">
                      {selectedApplication.linkedin_url || selectedApplication.candidate_profile?.linkedin_url ? (
                        <a href={selectedApplication.linkedin_url || selectedApplication.candidate_profile?.linkedin_url} target="_blank" rel="noopener noreferrer" style={{ color: '#0077b5', textDecoration: 'none' }}>
                          View Profile
                        </a>
                      ) : 'N/A'}
                    </span>
                  </div>
                </div>
              </div>

              {(selectedApplication.skills || selectedApplication.candidate_profile?.skills || []).length > 0 && (
                <div className="modal-section">
                  <h3><i className="fas fa-code"></i> Skills</h3>
                  <div className="modal-skills">
                    {(selectedApplication.skills || selectedApplication.candidate_profile?.skills || []).map((skill, idx) => (
                      <span key={idx} className="modal-skill-tag">{skill}</span>
                    ))}
                  </div>
                </div>
              )}

              <div className="modal-section resume-section">
                <h3><i className="fas fa-file-pdf"></i> Resume</h3>
                {selectedApplication.resume_url || selectedApplication.resume_key ? (
                  <div className="resume-actions">
                    <button className="resume-view-btn" onClick={() => handleViewResume(selectedApplication)}>
                      <i className="fas fa-eye"></i> View Resume
                    </button>
                    <button className="resume-download-btn" onClick={() => handleDownloadResume(selectedApplication)}>
                      <i className="fas fa-download"></i> Download
                    </button>
                    <span className="resume-filename">
                      <i className="fas fa-file-pdf"></i>
                      {selectedApplication.resume_filename || 'Resume.pdf'}
                    </span>
                  </div>
                ) : (
                  <div className="resume-not-available">
                    <i className="fas fa-info-circle"></i>
                    <span>Resume not uploaded by candidate</span>
                  </div>
                )}
              </div>

              <div className="modal-section">
                <h3><i className="fas fa-file-alt"></i> Documents Status</h3>
                <div className="modal-documents-status">
                  <span className="modal-label">Submission Status:</span>
                  {getDocumentsStatusDisplay(selectedApplication.documents_status || 'not_submitted')}
                </div>
              </div>

              <div className="modal-section">
                <h3><i className="fas fa-calendar-alt"></i> Training Details</h3>
                <div className="modal-details-grid">
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-calendar-plus"></i> Training Joining Date</span>
                    <span className="modal-value">{selectedApplication.training_join_date ? formatDate(selectedApplication.training_join_date) : 'N/A'}</span>
                  </div>
                  <div className="modal-detail-item">
                    <span className="modal-label"><i className="fas fa-calendar-minus"></i> Training Ending Date</span>
                    <span className="modal-value">{selectedApplication.training_end_date ? formatDate(selectedApplication.training_end_date) : 'N/A'}</span>
                  </div>
                </div>
              </div>

              {selectedApplication.payment_details && selectedApplication.payment_details.length > 0 && (
                <div className="modal-section">
                  <h3><i className="fas fa-money-bill-wave" style={{ color: '#27ae60' }}></i> Payment Details</h3>
                  <div className="payment-details-table-container">
                    <table className="payment-details-table">
                      <thead>
                        <tr>
                          <th>Month</th>
                          <th>Govt. Status</th>
                          <th>Govt. Date</th>
                          <th>Candidate Status</th>
                          <th>Payment Date</th>
                          <th>Remark</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedApplication.payment_details.map((payment, idx) => (
                          <tr key={idx}>
                            <td>
                              <strong>{payment.stipend_month_display || formatMonthDisplay(payment.stipend_month)}</strong>
                              {payment.month_count && (
                                <span className="payment-entry-count" title={`${payment.count} entries for this month`}>
                                  {payment.month_count}
                                </span>
                              )}
                            </td>
                            <td>
                              <span className={`payment-status-badge ${payment.government_status === 'received' ? 'status-received' : payment.government_status === 'not_received' ? 'status-not-received' : 'status-pending'}`}>
                                {payment.government_status === 'received' ? 'Received' :
                                  payment.government_status === 'not_received' ? 'Not Received' : 'Pending'}
                              </span>
                            </td>
                            <td>{payment.government_date_display || (payment.government_date ? formatDate(payment.government_date) : 'N/A')}</td>
                            <td>
                              <span className={`payment-status-badge ${payment.candidate_status === 'paid' ? 'status-paid' : payment.candidate_status === 'not_paid' ? 'status-not-paid' : 'status-pending'}`}>
                                {payment.candidate_status === 'paid' ? 'Paid' :
                                  payment.candidate_status === 'not_paid' ? 'Not Paid' : 'Pending'}
                              </span>
                            </td>
                            <td>{payment.candidate_date_display || (payment.candidate_date ? formatDate(payment.candidate_date) : 'N/A')}</td>
                            <td>{payment.remark || 'N/A'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}

              {selectedApplication.answers && selectedApplication.answers.length > 0 && (
                <div className="modal-section answers-section">
                  <h3><i className="fas fa-clipboard-list"></i> Application Form Answers</h3>
                  <div className="modal-answers-horizontal">
                    {selectedApplication.answers.map((answer, idx) => (
                      <div key={idx} className="horizontal-answer-item">
                        <div className="horizontal-answer-header">
                          <span className="answer-number">{idx + 1}.</span>
                          <span className="answer-field">{answer.field_name || 'Question'}</span>
                          {answer.is_required && <span className="required-badge">Required</span>}
                          <span className="field-type-badge">{answer.field_type || 'text'}</span>
                        </div>
                        <div className="horizontal-answer-value">
                          {answer.file_url ? (
                            <div className="answer-file">
                              <i className="fas fa-file-pdf"></i>
                              <a href={answer.file_url} target="_blank" rel="noopener noreferrer" className="file-download-link">
                                {answer.file_name || 'Download File'}
                              </a>
                            </div>
                          ) : (
                            <span className="answer-text">{answer.value || 'N/A'}</span>
                          )}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedApplication.notes && (
                <div className="modal-section notes-section">
                  <h3><i className="fas fa-sticky-note"></i> Notes</h3>
                  <p className="modal-notes">{selectedApplication.notes}</p>
                </div>
              )}

              <div className="modal-actions-app">
                <button className="btn-close-modal" onClick={handleCloseModal}>Close</button>
                <button className="btn-whatsapp-modal" onClick={() => handleSendWhatsApp(selectedApplication)}>
                  <FontAwesomeIcon icon={faWhatsapp} /> Message
                </button>

                {selectedApplication.status === 'shortlisted' && (
                  <>
                    <button className="btn-interview" onClick={() => handleUpdateStatus(selectedApplication.id, 'interview')}>
                      <i className="fas fa-handshake"></i> Interview
                    </button>
                    <button className="btn-offer" onClick={() => handleUpdateStatus(selectedApplication.id, 'offered')}>
                      <i className="fas fa-gift"></i> Offer
                    </button>
                    <button className="btn-reject" onClick={() => handleUpdateStatus(selectedApplication.id, 'rejected')}>
                      <i className="fas fa-times-circle"></i> Reject
                    </button>
                  </>
                )}

                {selectedApplication.status === 'interview' && (
                  <>
                    <button className="btn-offer" onClick={() => handleUpdateStatus(selectedApplication.id, 'offered')}>
                      <i className="fas fa-gift"></i> Offer
                    </button>
                    <button className="btn-reject" onClick={() => handleUpdateStatus(selectedApplication.id, 'rejected')}>
                      <i className="fas fa-times-circle"></i> Reject
                    </button>
                  </>
                )}

                {selectedApplication.status === 'offered' && (
                  <>
                    <button className="btn-hire" onClick={() => handleUpdateStatus(selectedApplication.id, 'joined')}>
                      <i className="fas fa-check-circle"></i> Confirm Joined
                    </button>
                    <button className="btn-reject" onClick={() => handleUpdateStatus(selectedApplication.id, 'rejected')}>
                      <i className="fas fa-times-circle"></i> Reject
                    </button>
                  </>
                )}

                {['rejected', 'withdrawn'].includes(selectedApplication.status) && (
                  <button className="btn-review" onClick={() => handleUpdateStatus(selectedApplication.id, 'applied')}>
                    <i className="fas fa-undo"></i> Reconsider
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      <JoinedFormView
        isOpen={showFormViewModal}
        onClose={() => {
          setShowFormViewModal(false);
          setFormViewData(null);
          setSelectedApplication(null);
        }}
        application={selectedApplication}
        formData={formViewData}
        loading={loadingFormView}
      />
    </div>
  );
};

export default ViewApplications;